import React, { useState, useRef, useEffect} from 'react';
import '../Modal.css';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  children: React.ReactNode;
}

const ModalEliminacion: React.FC<ModalProps> = ({ isOpen, onClose, onConfirm, children }) => 
{
  const [securityCode, setSecurityCode] = useState<string>('');
  const [inputCode, setInputCode] = useState<string>('');
  const [generatedCode, setGeneratedCode] = useState<string>('');
  const [error, setError] = useState<string | null>(null);
  const cancelButtonRef = useRef<HTMLButtonElement | null>(null);
  const modalRef = useRef<HTMLDivElement>(null); // Ref para el contenedor del modal

  useEffect(() => 
  {
    if (isOpen) 
    {
      // Generar un código de 4 dígitos cuando el modal está abierto
      const code = (Math.floor(1000 + Math.random() * 9000)).toString();
      setGeneratedCode(code);
      setSecurityCode(code);
      setInputCode('');
      setError(null);
      if (cancelButtonRef.current)
        cancelButtonRef.current.focus(); // Focus the cancel button by default
    }
  }, [isOpen]);

    //-----------------------------------------------------------

  useEffect(() => 
  {
      // Función para manejar clics fuera del componente
      const handleClickOutside = (event: MouseEvent) => 
      {
          if (modalRef.current && !modalRef.current.contains(event.target as Node))
              onClose();
      };
  
      // Función para manejar presiones de teclas
      const handleEscPress = (event: KeyboardEvent) => 
      {
          if (event.key === 'Escape') 
              onClose();
      };
  
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscPress);
  
      return () => 
      {
          document.removeEventListener('mousedown', handleClickOutside);
          document.removeEventListener('keydown', handleEscPress);
      };
  }, [onClose]);  

  //-----------------------------------------------------------

  const handleConfirm = () => 
  {
    if (inputCode === generatedCode)
      onConfirm();
    else
      setError('Código incorrecto. Por favor, inténtelo de nuevo.');
  };

  //-----------------------------------------------------------

  if (!isOpen) return null;

  return (
    <div className="modal" onClick={onClose} >
      <div className="modal-content" onClick={(e) => e.stopPropagation()} ref={modalRef}>
        <div className="modal-header">
          <h2 className="modal-title">Confirmar Eliminación</h2>
        </div>
        <div className="modal-body">
          {children}
          <div className="modal-security">
            <p>Introduce el código de seguridad: {securityCode}</p>
            <input
              type="text"
              value={inputCode}
              onChange={(e) => setInputCode(e.target.value)}
              placeholder="Código de 4 dígitos"
              maxLength={4}
              pattern="\d*"
              title="Código de 4 dígitos"
            />
            {error && <p className="error-message">{error}</p>}
          </div>
        </div>
        <div className="modal-footer">
          <button 
            className="modal-button cancel"
            onClick={onClose}
            ref={cancelButtonRef} // Focus this button by default
          >
            Cancelar
          </button>
          <button 
            className="modal-button confirm"
            onClick={handleConfirm}
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalEliminacion;
